import classNames from 'classnames';
import { CSSProperties, FC } from 'react';

import { FormattedMessage } from '../Intl';

type CountdownTimerIconPosition = 'BEFORE' | 'AFTER';

export interface CountdownTimerProps {
  className?: string;
  color: string;
  compact?: boolean;
  icon?: string;
  iconPosition?: CountdownTimerIconPosition;
  remainingTimeInSeconds: number;
  style?: CSSProperties;
  e2e?: string;
}

export const CountdownTimer: FC<CountdownTimerProps> = ({
  className,
  color,
  compact = false,
  icon = 'timer',
  iconPosition = 'AFTER',
  remainingTimeInSeconds,
  style,
  e2e,
}) => {
  const margin = compact ? '1' : '2';
  return (
    <div
      className={classNames(
        'badge rounded-pill',
        `badge-discreet-${color} bg-${color} text-${color} bg-opacity-10`,
        className,
      )}
      style={style}
      data-e2e={e2e ?? 'countdown-timer'}
    >
      {iconPosition === 'BEFORE' && <i className={`icon me-${margin}`}>{icon}</i>}
      <span className="remaining-time">
        <FormattedMessage
          id="sidePanel.countdown.seconds"
          values={{ value: remainingTimeInSeconds }}
          defaultMessage="s"
        />
      </span>
      {iconPosition === 'AFTER' && <i className={`icon ms-${margin}`}>{icon}</i>}
    </div>
  );
};
